<template>
  <div class="videoBox">
    <div v-if="size == 'mini'">
      <div id="contentHolder" class="flexBox">
        <video style="width:160px;height:120px;margin:0 auto" id="videos" width="160" height="120" autoplay
          ref="videos"></video>
      </div>
      <canvas width="160" height="120" ref="canvas" style="display:none;"></canvas>
    </div>
    <div v-else>
      <div id="contentHolder" class="flexBox">
        <video style="width:240px;height:200px;margin:0 auto" id="videos" width="240" height="200" autoplay
          ref="videos"></video>
      </div>
      <canvas width="240" height="200" ref="canvas" style="display:none;"></canvas>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      default: ""
    },
    size: {
      default: 'mini'
    }
  },
  created() {
    this.initVido();
  },
  destroyed() {
    this.close()
  },
  methods: {
    close() {
      if (!this.$refs['videos'].srcObject) return
      let stream = this.$refs['videos'].srcObject
      let tracks = stream.getTracks()
      tracks.forEach(track => {
        track.stop()
      })
      this.$refs['videos'].srcObject = null
    },
    takePhoto(data) {
      this.$nextTick(() => {
        this.photoCanvasImage(data);
      });
    },
    photoCanvasImage(data) {
      const _this = this
      let img = document.getElementById("videos"); //获取标签
      let ctx = this.$refs["canvas"].getContext("2d");
      this.$nextTick(async () => {
        //在画布上定位图像
        if (this.size == 'mini') {
          ctx.drawImage(img, 0, 0, 160, 120);
        } else {
          ctx.drawImage(img, 0, 0, 240, 200);
        }
        let imgBase64 = this.$refs['canvas'].toDataURL('image/jpeg')
        //
        // console.log(this.type)
        if (this.type == 'kj') { //面授-直播课
          _this.$http.post_s('/student/pc/common/uploadImage', { base64Image: imgBase64 }).then(res => {
            _this.$http.post_s('/student/pc/courseware/uploadPhoto', { fullpath: res, ...data }).then(res => {
              _this.$emit('logPhoto_ok',res)
            }).catch(() => {
              _this.$emit('logPhoto_no')
            })
          }).catch(() => {
            _this.$emit('logPhoto_no')
          })
        }else{ //练习/考试
          _this.$http.post_s('/student/pc/common/uploadImage', { base64Image: imgBase64 }).then(r => {
            _this.$http.post_s('/student/pc/paper/uploadFaceCapture', { photoPath: r, ...data }).then(res => {
              _this.$emit('logPhoto_ok',res)
            }).catch(() => {
              _this.$emit('logPhoto_no')
            })
          }).catch(() => {
            _this.$emit('logPhoto_no')
          })
        }
      });
    },
    initVido() {
      if (navigator.getUserMedia && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices
          .getUserMedia({
            video: true
          })
          .then((stream) => {
            // 摄像头开启成功
            this.$refs["videos"].srcObject = stream;
            // 实时拍照效果
            this.$refs["videos"].play();
          })
          .catch((error) => {
            this.$message.error(`访问用户媒体设备失败${error.name}, ${error.message}`)
          });
      } else {
        this.$message.error('不支持访问用户媒体')
      }
    }
  }
};
</script>

<style scoped>
.videoBox {
  position: fixed;
  right: 15px;
  top: 115px;
  z-index: 99;
}

.flexBox {
  position: relative;
  display: flex;
  flex-direction: column;
}
.cameraBtn {
  width: 100%;
  position: absolute;
  bottom: -33px;
  left: 0px;
}
</style>
